<template>
  <v-card
    class="ma-0"
    width="100%"
    style="height: auto"
    elevation="2"
  >
    <v-app-bar
      flat
      class="my-0 mb-6 py-1 px-2"
      dense
      height="30"
    >
      <v-toolbar-title class="mt-4 me-4">{{ $t('branchesList') }}</v-toolbar-title>
      <div
        v-if="!isMobile && !isTablet && !mobileShow"
        style="width: 230px;"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </div>
      <v-spacer />
      <v-btn
        v-if="selected.length > 0 && !isMobile && !mobileShow"
        outlined
        @click="deletDialog = true"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('remove') }}
        </p>
        <v-icon>
          mdi-trash-can-outline
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        @shortkey="getItems"
        v-shortkey="['f5']"
        style="min-width: 35px !important;padding: 0 !important;"
      >
        <!-- <p class="mb-0 me-2">
          {{$t('refresh')}}
        </p> -->
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet && !mobileShow"
        outlined
        class="mt-4 ms-2"
        color="primary"
        height="32"
        @click="openBranchDialog('add')"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('new-branch') }}
        </p>
        <v-icon>
          mdi-plus
        </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row
      v-if="isMobile || isTablet"
      class="mx-0"
    >
      <v-col
        class="mb-4 px-2"
        cols="12"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-col
      cols="12"
      class="px-2"
      :class="{ 'mt-2': !isMobile && !isTablet , 'mt-0': isMobile || isTablet}"
    >
      <v-data-table
        v-if="headers"
        v-model="selected"
        :height="(isMobile || isTablet || mobileShow ? 323 : tableHeight)"
        fixed-header
        :headers="showHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :page.sync="page"
        :hide-default-header="isMobile || mobileShow"
        multi-sort
        :show-select="showSelect"
        item-key="id"
        class="mb-2 td-hide-border"
        style="border: 1px solid #e3e3e3;border-radius: 6px;"
        :footer-props="{
          showFirstLastPage: (!mobileShow ? true : false),
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus'
        }"
      >
        <template
          v-if="isMobile || mobileShow"
          v-slot:item="{ item, index }"
        >
          <tr :class="{'mobile-show': mobileShow}">
            <td class="px-0">
              <v-list-item
                class="data-table-list-items mobile-td-list-border-primary"
                dense
              >
                <v-list-item-icon>
                  <div class="d-flex">
                    <p class="mt-1">
                      {{ +index + +1 }}
                    </p>
                    <v-menu
                      offset-y
                    >
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          color="primary"
                          v-bind="attrs"
                          icon
                          v-on="on"
                        >
                          <v-icon
                            medium
                          >
                            mdi-dots-vertical
                          </v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item
                          link
                          @click="openBranchDialog('edit', item)"
                        >
                          <v-list-item-icon>
                            <v-icon class="mt-2">
                              mdi-clipboard-edit
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('edit')" />
                        </v-list-item>
                        <v-list-item
                          v-show="removePermission(typeForm)"
                          link
                          @click="openDeleteDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon color="pink">
                              mdi-trash-can-outline
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remove')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    {{ item.name }}({{ item.code }})
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </td>
          </tr>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                v-bind="attrs"
                icon
                v-on="on"
              >
                <v-icon
                  medium
                >
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item
                link
                @click="openBranchDialog('edit', item)"
              >
                <v-list-item-icon>
                  <v-icon class="mt-2">
                    mdi-clipboard-edit
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-show="removePermission(typeForm)"
                link
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink">
                    mdi-trash-can-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.row="{ item }">
          <v-card-text
            class="pa-0 text-caption text-disable"
          >
            {{ parseInt(items.indexOf(item)) + parseInt(from) }}
          </v-card-text>
        </template>
        <template v-slot:item.branchId="{ item }">
          <v-card-text 
            class="pa-0"
            :class="{ 'text-body-2': item.id, 'text-caption': item.id == null }"
            style="color: #0066ff;cursor: pointer;"
            @click="openBranchDialog('edit', item)"
          >
            {{ item.id ? item.id : $t('haveNot') }}
          </v-card-text>
        </template>
        <template v-slot:item.branchName="{ item }">
          <v-card-text 
            class="pa-0"
            :class="{ 'text-body-2': item.name, 'text-caption': item.name == null }"
            style="color: #0066ff;"
          >
            {{ item.name ? item.name : $t('haveNot') }}
          </v-card-text>
        </template>
        <template v-slot:item.connectionInfo="{ item }">
          <v-card-text 
            class="pa-0"
            :class="{ 'text-body-2': item.phone, 'text-caption': item.phone == null }"
          >
            {{ item.phone ? item.phone : $t('haveNot') }}
          </v-card-text>
        </template>
        <template v-slot:item.address="{ item }">
          <v-card-text 
            class="pa-0"
            :class="{ 'text-body-2': item.address, 'text-caption': item.address == null }"
          >
            {{ item.address ? item.address : $t('haveNot') }}
          </v-card-text>
        </template>
        <template v-slot:item.internal_code="{ item }">
          <v-card-text 
            class="pa-0"
            :class="{ 'text-body-2': item.internal_code, 'text-caption': item.internal_code == null }"
          >
            {{ item.internal_code ? item.internal_code : $t('haveNot') }}
          </v-card-text>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
            :color="item.status == 'active' ? 'success' : 'error'"
            label
            small
          >
            {{ $t(item.status) }}
          </v-chip>
        </template>
        <template v-slot:footer.prepend>
          <v-col
            v-show="!isMobile"
            cols="1"
            class="pa-0"
            style="margin-top: -10px"
          >
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
    <!--dialog branch (add + edit)-->
    <v-dialog
      v-model="branchDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card class="pa-5" height="485">
        <v-form ref="form" v-model="valid">
          <v-container class="pa-0 d-flex justify-space-between">
            <v-card-text class="pa-0 text-body-1">
              {{ branchDialogType == 'add' ?  $t('new-branch') : $t('edit-branch') }}
            </v-card-text>
            <v-icon @click="branchDialog = false" style="cursor: pointer;">mdi-close</v-icon>
          </v-container>
          <v-container class="pa-0 wrapper ma-0 mt-3">
            <div
              v-for="(item, index) in activatorOptions"
              :key="index"
              class="flex-fill pa-2 d-flex justify-center"
              @click="selectStatus(item)"
              :style="{
                'background-color': newBranch.selectedStatus == item.value ? 'rgb(229, 254, 237)' : '',
                'border-color': newBranch.selectedStatus == item.value ? 'silver' : 'silver',
                'color': newBranch.selectedStatus == item.value ? 'rgb(19, 115, 51)' : ''
                }"
            >
              <v-card-text
                class="pa-0 text-caption"
              >
                {{ item.label }}
              </v-card-text>
            </div>
          </v-container>
          <v-text-field
            v-model="newBranch.name"
            :label="$t('branch-name')"
            outlined
            height="32"
            dense
            class="mt-5"
            :rules="[v => !!v || $t('is-required')]"
          />
          <v-text-field
            v-model="newBranch.internal_code"
            :label="$t('internal_code')"
            outlined
            height="32"
            dense
            class="mt-8"
          />
          <v-text-field
            v-model="newBranch.phone"
            :label="$t('phone-number')"
            outlined
            height="32"
            class="mt-8"
            dense
            :rules="[v => !!v || $t('is-required')]"
          />
          <v-textarea
            v-model="newBranch.address"
            :label="$t('address')"
            outlined
            dense
            class="mt-8 resize-none"
            rows="5"
            :rules="[v => !!v || $t('is-required')]"
          />
          <v-container 
            class="pa-0 d-flex align-center gap-2"
            style="margin-top: 148px;"
          >
            <v-btn
              color="primary"
              height="32"
              @click="checkValidation"
            >
            {{ branchDialogType == 'add' ? $t('confirm') : $t('edit') }}
            </v-btn>
            <v-btn
              color="secondary"
              height="32"
              outlined
              @click="branchDialog = false"
            >
            {{ $t('cancel') }}
            </v-btn>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!--delete dialog items of list-->
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                :loading="loading"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
    <Confirm ref="confirm" />
  </v-card>
</template>

<script>
  import General from '../../../../Mixins/general'
  export default {
    name: 'BranchList',
    components: {
      autocomplete: () => import('../../components/general/patial/autocomplete')
    },
    mixins: [General],
    props: ['input', 'type', 'refId', 'mobileShow', 'titleProp'],
    data: () => ({
      selected: [],
      pageCount: 1,
      page: 1,
      selectedHeaders: [],
      deletDialog: false,
      showSelect: true,
      model: null,
      from: 1,
      temp: null,
      deleteItem: [],
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      typeForm: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      search: null,
      branchDialog: false,
      branchDialogType: null,
      valid: true,
      newBranch: {
        name: null,
        internal_code: null,
        phone: null,
        address: null,
        selectedStatus: null
      },
      editedIndex: null,
      editedItem: null
    }),
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          return app.selectedHeaders.includes(s)
        })
      },
      activatorOptions () {
        return [
          { label: this.$t('active'), value: 'active' },
          { label: this.$t('deactive'), value: 'deactive' }
        ]
      }
    },
    watch: {
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected (val) {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
          this.deleteItem = this.selected
          console.log(JSON.stringify(this.deleteItem))
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        app.page = 1
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
        immediate: false,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
    },
    mounted () {
      this.newBranch.selectedStatus = 'active'
    },
    beforeMount () {
      if (this.$route.name === 'branchesList') {
        this.typeForm = 'branches'
      }
      this.headers = [
        {
          text: this.$t('operation'),
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 20,
        },
        {
          text: this.$t('#'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 20,
        },
        {
          text: this.$t('id'),
          sortable: false,
          value: 'branchId',
        },
        {
          text: this.$t('branch-name'),
          sortable: true,
          value: 'branchName'
        },
        {
          text: this.$t('connection-info'),
          sortable: false,
          value: 'connectionInfo',
        },
        {
          text: this.$t('address'),
          sortable: false,
          value: 'address',
        },
        {
          text: this.$t('internal_code'),
          sortable: false,
          value: 'internal_code',
        },
        {
          text: this.$t('status'),
          sortable: false,
          value: 'status',
        },
      ]
      if (this.input) {
        this.model = this.input
      }
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
    },
    methods: {
      openDeleteDialog (item) {
        this.deleteItem.push(item)
        this.deletDialog = true
        console.log(JSON.stringify(this.deleteItem))
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'branch/list', {
          params: {
            type: 'all',
            search: app.search,
            options: app.options,
            page: app.page
          },
        })
          .then(res => {
            res = res.data
            app.items = res.data
            app.totalItems = res.total
            app.pageCount = res.last_page
            app.from = res.from
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        app.loading = true
        app.$axios.delete(this.$endpoint + 'branch/' + this.deleteItem.map(item => item.id))
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        var selected = []
        app.selected.map(function (value, key) {
          selected.push({ id: value.id })
        })
        app.$axios.get(this.$endpoint + 'branch/list', {
          params: {
            deleteItems: selected,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      openBranchDialog (type, item) {
        this.branchDialogType = type
        this.branchDialog = true
        if (this.branchDialogType == 'add') {
          this.clearModal()
        }
        if (this.branchDialogType == 'edit' && item != undefined) {
          this.newBranch = {
            name: item.name,
            internal_code: item.internal_code,
            phone: item.phone,
            address: item.address,
            selectedStatus: item.status
          }
          this.editedIndex = this.items.findIndex(obj => item.id != undefined ? obj.id == item.id : obj.name == item.name)
          this.editedItem = this.items.find(obj => obj.id == item.id)
        }
      },
      clearModal () {
        this.newBranch = {
          name: null,
          internal_code: null,
          phone: null,
          address: null,
          selectedStatus: 'active'
        }
        if (this.$refs.form) {
          this.$refs.form.reset()
        }
      },
      checkValidation () {
        if (this.branchDialogType == 'add' && this.$refs.form.validate()) {
          this.addBranch()
        }
        if (this.branchDialogType == 'edit' && this.$refs.form.validate()) {
          this.editBranch()
        }
      },
      addBranch () {
        var app = this
        app.loading = true
        app.$axios.post(this.$endpoint + 'branch', {
          name: this.newBranch.name,
          internal_code: this.newBranch.internal_code,
          phone: this.newBranch.phone,
          address:this.newBranch.address,
          status: this.newBranch.selectedStatus
        })
          .then(res => {
            if (res) {
              this.items.push(this.newBranch)
              this.branchDialog = false
              this.getItems()
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      editBranch () {
        var app = this
        app.loading = true
        app.$axios.put(this.$endpoint + 'branch/' + this.editedItem.id, {
          name: this.newBranch.name,
          internal_code: this.newBranch.internal_code,
          phone: this.newBranch.phone,
          address:this.newBranch.address,
          status: this.newBranch.selectedStatus
        })
          .then(res => {
            if (res) {
              this.items.splice(this.editedIndex, 1, this.newBranch)
              this.branchDialog = false
              this.getItems()
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      selectStatus (item) {
        this.newBranch.selectedStatus = item.value
      }
    },
  }
</script>

<style scoped>
::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
::v-deep .v-input--selection-controls__input {
  margin-left: 0;
  width: auto;
}
::v-deep .v-input--selection-controls__ripple {
  width: auto;
  height: auto;
  margin: 0;
}
::v-deep .v-btn--icon.v-size--default {
  height: auto;
  width: auto;
}
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:nth-child(odd),
::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:nth-child(even) {
  /* background-color: transparent !important; */
  height: 60px;
}
.v-card__text {
  width: auto;
}
.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
.resize-none ::v-deep(textarea) {
  resize: none;
}
.wrapper {
  border: 1px solid silver;
  border-radius: 4px;
  display: flex;
  align-items: center;
  width: 55%;
}
.wrapper > div {
  border-left: 1px solid silver;
  cursor: pointer;
}
.wrapper > div:last-child {
  border-left: 0 !important;
}
@media (max-width: 863px) {
  ::v-deep .v-data-table table tbody tr,
  ::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:nth-child(odd),
  ::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:nth-child(even) {
    height: auto;
  }
}
</style>
